import actions from './actions'
import state from './state'
import mutations from './mutations'


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/Permission/index.js